import {
  ZmContext,
  ZmBadge,
  ZmCheckbox,
  ZmCheckboxGroup,
  ZmDialog,
  ZmForm,
  ZmInput,
  ZmInputNumber,
  ZmLoading,
  ZmTooltip,
  ZmDropdown,
  ZmPinCode,
  ZmRadio,
  ZmRadioGroup,
  ZmVirtualTable,
  ZmBreadcrumb,
  ZmTabs,
  ZmIcon,
  ZmSelect,
  ZmSelectOption,
  ZmSelectOptionGroup,
  ZmLink,
  ZmTag,
  ZmTagGroup,
  ZmSkeleton,
  ZmPopover,
  ZmDrawer,
  ZmAccordion,
  ZmAutocomplete,
  ZmVirtualFilterSelect,
  ZmToast,
  ZmTable,
  ZmRow,
  ZmCol,
  ZmCarousel,
  ZmCountrySelect,
  ZmPagination,
  ZmCaptcha
} from '@zoom/zoom-ui-vue3';

import { ZmMessage } from '@/components/zoom-ui-plus/message/index';

import {
  PlanComparison,
  PlanComparisonMobile,
  AutoExpireBadge,
  WebinarExplainDialog,
  ZoomOneEduPlanDetailDialog,
  ZoomOneEduPlanComparison,
} from '@zoom/fe-billing-components';

import PriceVatTip from "@/components/price-vat-tip.vue";

import Alert from '@/components/zoom-ui-plus/monitor-alert/index.vue';
import MessageBox from "@/components/common/message-box";
import ZmButton from '@/components/zoom-ui-plus/button/index.vue';
import TipsIcon from '@/components/tips-icon/index.vue';

// V3-TODO need verify
export default function installZoomUI(app) {
  app.use(ZmContext)
  app.use(ZmBadge)
  app.use(ZmToast)
  // Replace original ZmButton with our wrapper that supports round property
  app.component('ZmButton', ZmButton)
  app.use(ZmLink)
  app.use(ZmTabs)
  app.use(ZmIcon)
  // app.use(ZmBanner)
  app.use(ZmLoading)
  app.use(ZmSelect)
  app.use(ZmInput)
  app.use(ZmInputNumber)
  app.use(ZmTooltip)
  app.use(ZmCheckbox)
  app.use(ZmCheckboxGroup)
  app.use(ZmDropdown)
  app.use(ZmDialog)
  app.use(ZmTag)
  app.use(ZmTagGroup)
  app.use(ZmSkeleton)
  app.use(ZmBreadcrumb)
  app.use(ZmForm)
  app.use(ZmVirtualTable)
  app.use(ZmPinCode)
  app.use(ZmRadio)
  app.use(ZmRadioGroup)
  app.use(ZmPopover)
  app.use(ZmDrawer)
  app.use(ZmAccordion)
  app.use(ZmAutocomplete)
  app.use(ZmVirtualFilterSelect)
  app.use(ZmTable)
  app.use(ZmRow)
  app.use(ZmCol)
  app.use(ZmCarousel)
  app.use(ZmCountrySelect)
  app.use(ZmPagination)
  app.use(ZmCaptcha)

  app.use(ZmMessage)
  // ! note: use MessageBox to replace ZmMessageBox
  app.use(MessageBox);
  // ! note: use Alert to replace ZmBanner
  app.component('ZmAlert', Alert);
  app.component('ZmBanner', Alert);
  app.component("priceVATTip", PriceVatTip);
  app.component("ZmOption", ZmSelectOption);
  app.component("ZmOptionGroup", ZmSelectOptionGroup);
  app.component("TipsIcon", TipsIcon);

  // register components from '@zoom/fe-billing-components'
  app.component("PlanComparison", PlanComparison);
  app.component("PlanComparisonMobile", PlanComparisonMobile);
  app.component("AutoExpireBadge", AutoExpireBadge);
  app.component("WebinarExplainDialog", WebinarExplainDialog);
  app.component("ZoomOneEduPlanDetail", ZoomOneEduPlanDetailDialog);
  app.component("ZoomOneEduPlanComparison", ZoomOneEduPlanComparison);
}


// Vue.component('ZmTooltip', Tooltip);
// Vue.component('ZmTag', Tag);
// Vue.component('ZmTagGroup', TagGroup);
// Vue.component('ZmAlert', Alert);

// The zbo-checkbox-list component has been removed in Vue 3
// import CheckboxList from '@zoom/zoom-ui/src/components/checkbox-list';

// V3-TODO @Chase Xu > need verify
